export default __webpack_public_path__ + "static/media/multi_asset.3dd225f2.svg";